<template>
    <div class="deshboard">
        <div class="xs-index">
            <div class="login">
                <input class="pwd" type="password" @click="clearError" v-on:keyup.enter="login" v-model="password" placeholder="请输入密码" autocomplete="off" />
                <input class="btn" type="button" value="登录" @click="login" />
                <div class="error">
                    {{ errorMsg }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { login } from '@/assets/scripts/api/login';

    export default {
        name: 'login',
        data() {
            return {
                password: '',
                errorMsg: ''
            };
        },
        mounted() {
            this.checkLogin();
        },
        methods: {
            checkLogin() {
                let that = this;

                login(this.password).then((res) => {
                    if (res.code == 0) {
                        that.$store.dispatch('loginAction');
                        that.$router.push({ path: '/' });
                    }
                });
            },
            login() {
                let that = this;

                login(this.password).then(() => {
                    if (that.password == that.$store.state.pwd) {
                        that.$store.dispatch('loginAction');

                        let fromUrl = that.$router.history.current.query.from;

                        if (fromUrl) {
                            location.href = fromUrl;
                        } else {
                            that.$router.push({ path: '/' });
                        }
                    } else {
                        that.errorMsg = '请输入正确的密码';
                    }
                });
            },
            clearError() {
                this.errorMsg = '';
            }
        }
    };
</script>

<style lang="scss">
.header {
    display: none;
}

.login {
    position: absolute; top: 66%; left: 50%;
    width: 550px;
    height: 60px;
    margin-top: -30px; margin-left: -275px;
    border: 1px solid #1470ff;
    background-color: rgba(20, 122, 255, .6);
    box-shadow: 0 0 20px #152ca6;

    .pwd {
        float: left;
        width: 400px;
        height: 60px;
        padding: 21px 10px;
        line-height: 18px;
        border: none;
        background: none;
        color: #fff;
        font-size: 16px;
        &::-webkit-input-placeholder {
          color: #fff;
          font-size: 16px;
        }
        &::-moz-placeholder {
          color: #fff;
          font-size: 16px;
        }
        &:-ms-input-placeholder {
          color: #fff;
          font-size: 16px;
        }
    }
    .btn {
        float: left;
        width: 148px;
        height: 58px;
        border: none;
        background-color: #1470ff;
        font-size: 18px; color: #fff;
    }
    .error {
        position: absolute; top: 60px; left: 0;
        color: red; font-size: 18px; line-height: 40px;
    }
}
.deshboard .xs-index {
    position: relative;
    width: 924px;
    height: 927px;
    margin: 0 auto;
    padding-top: 123px;
    background: url(/img/bg-1.145c9512.png) no-repeat center 123px;
    background-size: 100% 814px;
}
.navigator{
    display: none !important;
}
</style>

